import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.general.posReceiptInfoSettings.title',
    defaultMessage: 'POS receipt info',
    description: 'title of the pos receipt info settings on the configuration page',
  },
  feedback: {
    posReceiptInfoSettingsUpdated: {
      id: 'pages.settings.general.posReceiptInfoSettings.feedback.posReceiptInfoSettingsUpdated',
      defaultMessage: 'Channel information saved',
      description: 'feedback on the successful update of pos receipt information settings',
    },
    posReceiptInfoSettingsNotUpdated: {
      id: 'pages.settings.general.posReceiptInfoSettings.feedback.posReceiptInfoSettingsNotUpdated',
      defaultMessage: 'Channel information could not be saved',
      description: 'feedback on the failed update of pos receipt information settings',
    },
  },
  editDrawer: {
    title: {
      id: 'pages.settings.general.posReceiptInfoSettings.editDrawer.title',
      defaultMessage: 'Edit channel information',
      description: 'title of the edit pos receipt information settings drawer',
    },
    headerTextField: {
      label: {
        id: 'properties.headerText',
        defaultMessage: 'Header text',
        description: 'label of the header text field',
      },
    },
    footerTextField: {
      label: {
        id: 'properties.footerText',
        defaultMessage: 'Footer text',
        description: 'label of the footer text field',
      },
    },
    logoField: {
      label: {
        id: 'properties.logo',
        defaultMessage: 'Logo',
        description: 'label of the logo field',
      },
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
